import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ResourceUpdatesService } from 'core/http/project/resource-updates/resource-updates.service';
import { ownedError } from 'core/utils/owned-error';
import { projectScopedRequest } from 'core/utils/rx-common';
import { defer, of } from 'rxjs';
import { catchError, finalize, map, switchMap, throwIfEmpty } from 'rxjs/operators';
import * as ProjectResourcesActions from './project-resources.actions';

@Injectable()
export class ProjectResourcesEffects {
  private _requestVersion = 0;

  getResources$ = createEffect(() => this.actions$.pipe(
    ofType(ProjectResourcesActions.getProjectResources),
    map(() => {
      this._requestVersion += 1;
      return this._requestVersion;
    }),
    switchMap(version => defer(() => {
      this.store$.dispatch(ProjectResourcesActions.setLoading({ value: true }));
      return projectScopedRequest(this.store$, () => defer(() => this.resourceUpdatesService.getResourceChanges()).pipe(
        throwIfEmpty(() => ownedError(new Error('ERROR.project_resources_load_failed'), 'projectResources')),
        switchMap(resources => [
          ProjectResourcesActions.saveProjectResources({ resources }),
          ProjectResourcesActions.markProjectResourcesLoaded(),
        ]),
        catchError((error: Error) => of(ProjectResourcesActions.setError({ value: error }))),
      ));
    }).pipe(
      finalize(() => {
        if (version === this._requestVersion) {
          this.store$.dispatch(ProjectResourcesActions.setLoading({ value: false }));
        }
      }),
    )),
  ));

  constructor(
    private actions$: Actions,
    private resourceUpdatesService: ResourceUpdatesService,
    private store$: Store,
  ) {}
}
